export const SIGNIFICANT_CENTER_COUNT: number = 6
